import { MemberCard, MemberCardProps } from "./MemberCard";

export type MemberGridProps = {
  title: string;
  members: Array<MemberCardProps["member"]>;
};

export function MemberGrid({ title, members }: MemberGridProps) {
  return (
    <div className="container mb-8 last:mb-0 sm:mb-12 md:mb-16 3xl:mb-20">
      <h2 className="mb-6 text-2xl font-semibold text-marine sm:mb-8 sm:text-3xl md:text-4xl 3xl:mb-10 3xl:text-6xl">
        {title}
      </h2>

      <div className="grid grid-cols-1 gap-4 sm:gap-6 md:gap-8 lg:grid-cols-2 3xl:grid-cols-3 3xl:gap-10">
        {members.map((member, index) => (
          <MemberCard key={index} member={member} />
        ))}
      </div>
    </div>
  );
}
